import { translation } from '../core';
import type { fr } from './fr';

export const en = translation<typeof fr>()({
  'title.securePayment': 'Secure payment',
  'title.requestSent': 'Request sent',
  'title.trips': 'My trips',
  'title.favourites': 'Favourites',
  'title.profile': 'Profile',
  'title.messages': 'Messages',
  'title.reviews': 'My reviews',
  'title.login': 'Sign in',
  'title.register': 'Sign up',
  'title.password': 'Password',
  'title.partner': 'Join as a partner',
  'title.experienceBooked': 'Experience booked',
  'title.about': 'About',
  'title.faq': 'FAQ',
  'title.terms': 'Terms and conditions',
  'title.privacy': 'Privacy',
  'title.contact': 'Support',
  'title.blog': 'Journal',
  'title.article': 'Article',
  'title.agency': 'Agency',
  'title.notFound': 'Page not found',

  skipToContent: 'Skip to content',
  underConstruction: 'Under construction',

  securePayment: 'Secure payment · Stripe',
  agencyMode: 'Agency mode',
  becomePartner: 'Join as a partner',
  preferences: 'Language and currency',
  accountMenu: 'Account menu',
  universes: 'Vehicles or experiences',
  'messages.unread': { zero: 'Messages', one: 'Messages, {count} unread', other: 'Messages, {count} unread' },
  editSearch: 'Edit search',

  'nav.label': 'Main navigation',
  'nav.explore': 'Explore',
  'nav.trips': 'Trips',
  'nav.searchVehicle': 'Search for a vehicle',
  'nav.searchExperience': 'Search for an experience',
  'nav.profileUnread': {
    zero: 'Profile',
    one: 'Profile, {count} unread message',
    other: 'Profile, {count} unread messages',
  },

  'menu.label': 'Account',
  'menu.upcoming': '{count} upcoming',
  'menu.bookings': 'My bookings',
  'menu.agency': 'Agency',
  'menu.agencies': 'Agencies',
  'menu.support': 'Support',
  'menu.signedOut': 'You are signed out.',
  'menu.signOut': 'Sign out',

  'prefs.language': 'Language',
  'prefs.currency': 'Currency',
  'prefs.MAD': 'Dirham',
  'prefs.EUR': 'Euro',
  'prefs.USD': 'US dollar',
  'prefs.note': 'Prices are set in MAD. In EUR or USD the amount is indicative; the rate is fixed when you pay.',

  'footer.tagline': 'Car and motorbike rental and experiences from verified agencies in Morocco.',
  'footer.rent': 'Rent',
  'footer.account': 'Your account',
  'footer.about': 'About',
  'footer.faq': 'FAQ',
  'footer.blog': 'Blog',
  'footer.contact': 'Contact',
  'footer.copyright': '© {year} Cardnd · Verified agencies in Morocco',
  'footer.terms': 'Terms and conditions',
  'footer.privacy': 'Privacy',
  'footer.prices': 'Prices in MAD · Secure payment by Stripe',
  'newsletter.label': 'Cardnd newsletter',
  'newsletter.title': 'Offers and news by email',
  'newsletter.field': 'Your email',
  'newsletter.placeholder': 'you@example.com',
  'newsletter.submit': 'Subscribe',
  'newsletter.required': 'Enter your email.',
  'newsletter.invalid': 'Invalid email address.',
  'newsletter.done': 'Thank you! You will receive our offers and news. Unsubscribe in one click from any email.',

  'promo.payment.commission_only':
    'Pay a small part online to reserve. The rest? At the agency, keys in hand, contract signed.',
  'promo.payment.full':
    'Pay for your rental online to reserve: your card is only charged once the agency confirms. On arrival, all that is left is to pick up the keys.',
  'promo.payment.label': 'New: online payment',
  'promo.payment.tag': 'New — online payment',
  'promo.payment.title': 'Your car, held. <serif>Before you even land.</serif>',
  'promo.payment.ok': 'Got it',
  'promo.consent.label': 'Don’t miss any promotions',
  'promo.consent.title': 'Don’t miss any <serif>promotions.</serif>',
  'promo.consent.text':
    'Agree to receive our exclusive offers and promotions by email. You can unsubscribe at any time.',
  'promo.consent.accept': 'Yes, I want to receive offers',
  'promo.consent.later': 'Maybe later',
  'promo.consent.privacy': 'Your data is protected. See our <link>privacy policy</link>.',
  'promo.app.label': 'Cardnd app',
  'promo.app.title': 'The Cardnd app',
  'promo.app.text': 'Book faster, with your vouchers always on you.',
  'promo.app.open': 'Open',
  'promo.app.close': 'Close the banner',

  'chat.toast': '{name}: {text}',

  'error.title': 'Something went wrong',
  'error.text': 'Reload the page. If the problem persists, contact support.',
});
